export default [
    '#4CB050',
    '#0A714E',
    '#004AAD',
    '#0CC0DF',
    '#CB6CE6',
    '#FFBD59'
];